import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TOTAL_DESCARGA_POR_GRADO } from '../../../../config/tables'

function TotalDescargaPorGradoView () {
  return (
    <MuiTable id={TABLA_TOTAL_DESCARGA_POR_GRADO} />
  )
}

export default TotalDescargaPorGradoView
